
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent } from "vue";
const SearchInput = defineComponent({
  name: "SearchInput",
  emits: ["onSubmit", "update:modelValue"],
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  model: {
    prop: "modelValue",
    event: "update",
  },
  setup(props, context) {
    const search = (e: any) => {
      if (e.key === "Enter") {
        context.emit("onSubmit");
      }
    };
    return { search };
  },
});
export default SearchInput;
